import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles(() => ({
  blockName: {
    display: 'flex',
    alignItems: 'center',
    position: 'relative',
    color: 'var(--text-secondary)',
    fontWeight: 500,
    fontSize: '17px',
    lineHeight: '22px',
    marginBottom: '12px',
    paddingLeft: '12px',

    '&:not(:first-child)': {
      marginTop: '20px',

      '@media screen and (min-width: 1441px)': {
        marginTop: '28px',
      },
    },

    '@media screen and (min-width: 1441px)': {
      fontSize: '20px',
      lineHeight: '24px',
      marginBottom: '16px',
      paddingLeft: '16px',
    },
  },
}));

export default useStyles;
